import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAreaDestiny = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M24 10.6667C26.2091 10.6667 28 8.87581 28 6.66667C28 4.45753 26.2091 2.66667 24 2.66667C21.7909 2.66667 20 4.45753 20 6.66667C20 8.87581 21.7909 10.6667 24 10.6667Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M8 29.3333C10.2091 29.3333 12 27.5425 12 25.3333C12 23.1242 10.2091 21.3333 8 21.3333C5.79086 21.3333 4 23.1242 4 25.3333C4 27.5425 5.79086 29.3333 8 29.3333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M16 6.66667H11.3333C8.756 6.66667 6.66667 8.756 6.66667 11.3333C6.66667 13.9107 8.756 16 11.3333 16H20.6667C23.244 16 25.3333 18.0893 25.3333 20.6667C25.3333 23.244 23.244 25.3333 20.6667 25.3333H16",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgAreaDestiny;
